import type { EditorContentMode } from "../types";

export type EditorModeCapabilities = {
  advancedFormatting: boolean;
  automaticLinks: boolean;
  imageResize: boolean;
  imageUpload: boolean;
  linkOnPaste: boolean;
  tableColumnAlignment: boolean;
  tableControls: boolean;
  tableRichFormatting: boolean;
  tableResize: boolean;
  videoEmbed: boolean;
};

const RICH_TEXT_CAPABILITIES: EditorModeCapabilities = {
  advancedFormatting: true,
  automaticLinks: true,
  imageResize: true,
  imageUpload: true,
  linkOnPaste: true,
  tableColumnAlignment: true,
  tableControls: true,
  tableRichFormatting: true,
  tableResize: true,
  videoEmbed: true,
};

const MARKDOWN_CAPABILITIES: EditorModeCapabilities = {
  advancedFormatting: false,
  automaticLinks: false,
  imageResize: false,
  imageUpload: false,
  linkOnPaste: false,
  tableColumnAlignment: true,
  tableControls: true,
  tableRichFormatting: false,
  tableResize: false,
  videoEmbed: false,
};

export function getEditorModeCapabilities(mode: EditorContentMode) {
  return mode === "markdown" ? MARKDOWN_CAPABILITIES : RICH_TEXT_CAPABILITIES;
}
